import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Dialog, { DialogContent } from '@eversports/klimt-primitives/legacy/Dialog'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import { useRef } from 'react'

import CloseIcon from '../../../../assets/icons/close.svg'
import Drawer from '../../../../components/Drawer'

import ReferMobileImage from './assets/Refer-Mobile-or-sheet.webp'
import WideModalImage from './assets/Wide-modal.webp'
import { VenueReferAFriendOverlayContent } from './VenueReferAFriendOverlayContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
  venueName: string
  referralCode: string
  rewardDescription: string
}

export function VenueReferAFriendOverlay({ isOpen, toggleDialog, venueName, referralCode, rewardDescription }: Props) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const hasOpenedRef = useRef(false)

  if (isOpen) {
    hasOpenedRef.current = true
  }

  if (!hasOpenedRef.current) return null

  return isMobile ? (
    <Drawer open={isOpen} onClose={toggleDialog}>
      <VenueReferAFriendOverlayContent
        venueName={venueName}
        referralCode={referralCode}
        rewardDescription={rewardDescription}
        image={ReferMobileImage}
      />
    </Drawer>
  ) : (
    <Dialog open={isOpen} onClose={toggleDialog} maxWidth="md">
      <DialogContent>
        <Box sx={{ cursor: 'pointer', justifySelf: 'end', marginBottom: 1 }}>
          <Icon onClick={toggleDialog} src={CloseIcon} size="default" color="darkgray" />
        </Box>
        <VenueReferAFriendOverlayContent
          venueName={venueName}
          referralCode={referralCode}
          rewardDescription={rewardDescription}
          image={WideModalImage}
        />
      </DialogContent>
    </Dialog>
  )
}
